import {RouterStateSnapshot, ActivatedRouteSnapshot, Router, CanActivate} from '@angular/router';
import {AuthService} from 'ng2-ui-auth';
import {Injectable} from '@angular/core';
var swal = require('sweetalert2');
/**
 * Created by Ron on 03/10/2016.
 */
@Injectable()
export class AuthGuardAdminService implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}
  canActivate(
    next:  ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    const user = this.auth.getPayload().sub;

    console.log('AuthGuardAdminService');

    if (user.roles === 'ROLE_ADMIN') {
      return true;
    }

    this.router.navigateByUrl('login');

    swal('Permisos insufucientes', 'No tiene permisos para acceder a este modulo', 'error');

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard-admin/auth-guard-admin.service.ts